import dynamic from 'next/dynamic';

import { Container } from '@/atoms';

const Beer = dynamic(() => import('@/assets/images/Beer.svg'), { ssr: false });

/**
 * HeadBigcrafters
 */
const HeadBigcrafters = ({ bloque, id, className }: any) => (
  <Container id={id} wrapper as="section" {...(className && { className })}>
    <div className="flex flex-col items-center justify-center gap-8 md:flex-row">
      <div className="3x:text-9xl u-headline text-6xl xl:text-8xl">
        {bloque.textoIzquierda}
      </div>
      <Beer className="max-w-[300px] flex-shrink-0" />
      <div className="3x:text-9xl u-headline text-6xl xl:text-8xl">
        {bloque.textoDerecha}
      </div>
    </div>
  </Container>
);

HeadBigcrafters.displayName = 'HeadBigcrafters';

export default HeadBigcrafters;
